<template lang="pug">
div 
    doc-questions(:apiWeb='apiWeb',  :IsShowModal.sync="IsShowQuestions", :InfoGroup.sync="InfoGroupSelect"  )
    v-container( fluid)    
        v-row
            v-col(cols="9" sm="12" md="9")
                        div(v-show="false") {{IdDocCategory_}}
                        v-text-field(v-model="parameterInsert.Name"
                                label="Nombre Agrupacion Preguntas"
                                placeholder="Nombre Agrupacion Preguntas"
                                outlined
                                hide-details="auto" 
                                @keypress.enter="Insert()" 
                                )                  
            v-col(cols="3" sm="12" md="3") 
                v-btn(color="primary" @click="Insert()" block) ADD 
                    i.fa.fa-plus     
    v-container( fluid)
                v-simple-table(class="elevation-5" )
                    thead(class="elevation-1"  )
                        tr
                            th Editar
                            th N°
                            th Agrupacion Preguntas                         
                            th Estado 
                            th Preguntas                     
                    tbody(name="table-fade", is="transition-group") 
                        tr(v-if="tableInfo.length", v-for="(item,index) in tableInfo", :key="index")
                            td
                                button.btn.btn-sm.btn-info(v-if="item.Update==0", @click="item.Update = 1")     
                                    i.fa.fa-edit  
                                button.btn.btn-sm.btn-warning(v-else, @click="item.Update = 0; Update(item)")     
                                    i.fa.fa-floppy-o
                            td {{index+1}}
                            td
                                div(v-if="item.Update == 0") {{item.Name}} 
                                input.form-control.form-control-sm(v-else,v-model="item.Name", :readonly="item.Update==0 ? true:false")                            
                            td  
                                div(v-if="item.Update == 0") {{item.Active==1 ? 'Activo':'Inactivo'}}
                                select.form-control.form-control-sm(v-else, v-model="item.Active" , :disabled="item.Update==0 ? true:false")
                                    option(value=1) Activa
                                    option(value=0) Inactiva
                            td.text-center 
                                button.btn.btn-sm.btn-warning(@click="InfoGroupSelect=item, IsShowQuestions=true") 
                                    i.fa.fa-question-circle                        
                  
</template>
<script>
import modal from "../../../../complementos/modal.vue" 
import model from "../../../../models/docQuestionsCategory.js"
import docQuestions from './docQuestions/app.vue'

export default {
    props:{   
        InfoCategory:Object, 
        apiWeb:Object, 
    },  
    data(){
        return{
            nameModulo:'Agrupacion Preguntas',
            pathApi:'DocQuestionsCategory/DocQuestionsCategory',
            IsShowQuestions:false, 
            InfoGroupSelect:{},
            parameterUpdate:Object.assign({}, model.parameterUpdate),
            parameterInsert:Object.assign({}, model.parameterInsert),
            parameterView:Object.assign({}, model.parameterView), 
            IdDocCategoryOldValue:0,
            tableInfo:[] 
        }
    },
    components:{
        modal,
        docQuestions
    },
    computed:{
        isShowModal_ :{
                        get(){
                            this.List_Info()  
                            return this.IsShowModal 
                        },
                        set(val){
                            this.List_Info()  
                            this.$emit("update:IsShowModal",val)
                        }
        },
        IdDocCategory_ :{
                        get(){
                            if(this.IdDocCategoryOldValue!=this.InfoCategory.IdDocCategory){
                                this.IdDocCategoryOldValue=this.InfoCategory.IdDocCategory
                                this.List_Info()                                
                            }                                
                            return this.InfoCategory.IdDocCategory
                        },
                        set(val){ 
                            this.$emit("update:InfoCategory.IdDocCategory",val) 
                        }
            
        } 
    },
    mounted(){
        this.IdDocCategoryOldValue=this.IdDocCategory_
       this.List_Info()
    },
    methods:{
        List_Info(){   
            this.parameterView.IdDocCategory=this.IdDocCategory_
            this.apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value)                                     
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }, 
        Insert(){ 
            if(this.validate(this.parameterInsert)){
                this.parameterInsert.IdDocCategory=this.IdDocCategory_
                this.parameterInsert.User=this.$info.email
                this.parameterInsert.IP=this.$info.ip
                this.apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.parameterInsert=Object.assign({}, model.parameterInsert)
                                    this.$emit("change") 
                                    this.$msgbox.show("Ingresado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                    this.List_Info()
                                }

                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
            
        },
        Update(item){ 
            this.parameterUpdate.Name=item.Name 
            this.parameterUpdate.Active=item.Active 
            this.parameterUpdate.IdDocCategory=this.IdDocCategory_
            this.parameterUpdate.IdDocQuestionsCategory=item.IdDocQuestionsCategory 
            if(this.validate(this.parameterUpdate)){                
                this.parameterUpdate.User=this.$info.email
                this.parameterUpdate.IP=this.$info.ip 
                this.apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.IsShowModalUpdate=false
                                    this.$emit("change")
                                    this.$msgbox.show("Actualizado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                     this.List_Info()
                                }
                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
        },
        validate(parameter){ 
            if(parameter.Name=='' || parameter.Name==null ){
                this.$msgbox.show("Ingrese Nombre Agrupacion","Alerta")
                return false
            }                    
            else{
                return true
            }
        }
    }

    
}
</script>